<template>
  <div>
    <div>
      <!-- 使用组件 -->
      <MemberInfo></MemberInfo>
    </div>
    <div class="header-centers">
        <div>
          <el-card class="NumberCardWidth">
            <div class="deal flex-between">
              <div class="card-text">
                <h3>会员预约</h3>
              </div>
              <div class="card-button">
                <el-button class="push-button" @click="NvagetToLookMenber" icon="iconfont icon-fanhui" plain
                  >返回基本信息</el-button
                >
              </div>
            </div>
            <div class="NumberTable">
              <!-- table列表 -->
             <Table
              @TouchTheBottom="TouchTheBottom"
              :PagesData="paging"
              :tableData="list.tbody"
              :configTable="list.thead"
              :config="list"
            ></Table>
            </div>
          </el-card>
        </div>
        <!-- 右侧列表相关链接 -->
        <!-- 使用封装的组件 -->
        <div class="PagesContentRight">
          <RightCard></RightCard>
        </div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex"
import {
  GetSelectByCustID
} from "@/api/viewMemberModule";
import { getcpyNo } from "@/utils/auth";
import Table from "/src/components/NumberTable/index.vue";
export default {
  name: "centre",
  components: {
    Table: Table,
  },
  data() {
    return {
      paging: {
        page: 1,
        size: 50,
        total: 0,
        pages: 2,
        Loading: true,
      },
      list: {
        thead: [
          //设置表头
          {
            label: "",
            prop: "CopyIndex",
            width: 50,
          },
          {
            label: "预约编号",
            prop: "appointmentNo"
          },
          {
            label: "预约类型",
            prop: "kindText"
          },
          {
            label: "门店",
            prop: "shop"
          },
          {
            label: "日期",
            prop: "appointmentDate",
            width: 200,
          },
          {
            label: "时间",
            prop: "startTime",
            width: 200,
          },
          {
            label: "创建人",
            prop: "createUserName"
          },
          {
            label: "创建时间",
            prop: "createTime",
            width: 200,
          },
        ],
        tbody: [],
      },
    }
  },
   computed: {
    ...mapState({
      custID: (state) => state.user.custID,
    }),
  },
  created(){
      this.RGetSelectByCustID()
  },
  methods:{
    NvagetToLookMenber() {
      this.$router.push("/LookMember");
    },
    RGetSelectByCustID(){
        let data = require('qs').stringify({
        cpyNo: getcpyNo,
        custID: this.custID,
        pageSize: this.paging.size,
        pageNo: this.paging.page,
      });
      GetSelectByCustID(data).then((res) => {
        if (res.success) {
          this.paging.total = res.data.total;
          this.paging.pages = res.data.pages;
          res.data.list.forEach((item, index) => {
            item.CopyIndex =
              (this.paging.page - 1) * this.paging.size + index + 1;
            item.appointmentDate=this.renderTime(item.appointmentDate)
            item.createTime=this.renderTime(item.createTime)
            item.startTime=this.renderTime(item.startTime)
            item.kindText=item.kind==0?'试衣预约':item.kind==1?'售后服务':''
          });
          this.list.tbody =this.list.tbody.concat(res.data.list);
        } else {
          this.$message.error(res.message);
        }
        this.paging.Loading = false;
      });
    },
     renderTime(date) {
      if (date != null) {
        var dateee = new Date(date).toJSON();
        return new Date(+new Date(dateee) + 8 * 3600 * 1000)
          .toISOString()
          .replace(/T/g, " ")
          .replace(/\.[\d]{3}Z/, "");
      } else {
        return "";
      }
    },
     TouchTheBottom() {
      this.paging.page++;
      this.RGetSelectByCustID();
    },
  }
};
</script>
<style lang="scss" scoped>
.NumberCardWidth{
  width: 1265px;
}
.header-centers {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 10px;
}
.PagesContentRight {
  height: 990px;
  margin-left: 25px;
  display: flex;
  flex-direction: column;
  justify-self: flex-start;
  align-content: flex-start;
}
.NumberTable {
  margin-top: 40px;
}
.card-text {
  color: #a19b5a;
}
.push-button {
  background-color: #e9e7d3;
  border-radius: 7px;
  color: #a19b59;
}


</style>
